import { Image } from '@fluentui/react';
import React, { useMemo } from 'react';
import operation from './operation.png';

const Vignette = (props) => {

    const {
        src,
    } = props;

    const styles = useMemo(() => {
        return {
            root: {
                borderRadius: "50%",
                flexShrink: "0 !important"
            },
            image: {
                height: 40,
                width: 40
            }
        };
    }, []);

    return <Image src={src || operation} styles={styles} />;

};

export default Vignette;